var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-layout',{attrs:{"showNav":false}},[_c('div',{staticClass:"issueTicket-page"},[_c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"inner"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }